import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'reactstrap';

import * as generalActions from 'modules/general/action';
import * as registrosAction from '../action';

@connect(store => ({
  registros: store.getIn(['registros', 'list']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('REGISTROS'));
    this.props.dispatch(registrosAction.get());
  };
  editarReserva = (reservaId, viajeId) => this.props.dispatch(push('/dashboard/reservas/add/' + reservaId + '/' + viajeId));
  verViaje = viajeId => this.props.dispatch(push('/dashboard/reservas/pasajeros/' + viajeId));
  verAbonado = (usuarioId, abonadoId) => this.props.dispatch(push(usuarioId ? '/dashboard/abonados/add/' + usuarioId + '/true' : '/dashboard/abonados/add/' + abonadoId + '/false'));
  render() {
    const { registros } = this.props;
    return (
      <div>
        <Row className="rowContainer">
          <Col lg={{ size: 8, offset: 2 }} md="12">
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding">
                {registros.map(registro =>
                  componentRegistro(registro, {
                    editarReserva: this.editarReserva,
                    verViaje: this.verViaje,
                    verAbonado: this.verAbonado,
                  }),
                )}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </div>
    );
  }
}

function componentRegistro(registro, functions) {
  switch (registro.get('codigo')) {
    case 'RESERVA_CANCELADA_VIAJE_LLENO':
      return (
        <div key={registro.get('id')}>
          <MaterialUI.ListItem
            disabled
            className="noMargin"
            primaryText={
              <Row className="listIcon p-lr-10">
                <Col md="6" className="pt-10">
                  <p className="red">
                    <b>
                      <FontAwesome name="exclamation-triangle" /> {registro.get('codigo')}
                    </b>
                  </p>
                  <p>{registro.getIn(['data', 'errorMsg'])}</p>
                </Col>
                {registro.getIn(['data', 'viajeId']) && (
                  <Col md="2">
                    <MaterialUI.RaisedButton label="Viaje" onTouchTap={() => functions.verViaje(registro.getIn(['data', 'viajeId']))} secondary={true} fullWidth={true} />
                  </Col>
                )}
                {registro.getIn(['data', 'viajeId']) && (
                  <Col md="2">
                    <MaterialUI.RaisedButton
                      label="Reserva"
                      onTouchTap={() => functions.editarReserva(registro.getIn(['data', 'reservaId']), registro.getIn(['data', 'viajeId']))}
                      secondary={true}
                      fullWidth={true}
                    />
                  </Col>
                )}
                <Col md="2" className="pt-10">
                  <p>
                    <b>
                      <FontAwesome name="clock-o" /> {moment(registro.get('fechaCreado')).format('HH:mm')}
                    </b>
                  </p>
                </Col>
              </Row>
            }
          />
          <MaterialUI.Divider />
        </div>
      );
    case 'RESERVA_AUTOMATICA_NO_CREADA':
    case 'RESERVA_AUTOMATICA_ERROR_EN_TRAYECTO':
    case 'RESERVA_AUTOMATICA_NO_CREADA_ERROR':
      return (
        <div key={registro.get('id')}>
          <MaterialUI.ListItem
            disabled
            className="noMargin"
            primaryText={
              <Row className="listIcon p-lr-10">
                <Col md="6" className="pt-10">
                  <p className="red">
                    <b>
                      <FontAwesome name="exclamation-triangle" /> {registro.get('codigo')}
                    </b>
                  </p>
                  <p>{registro.getIn(['data', 'errorMsg'])}</p>
                </Col>
                {registro.getIn(['data', 'viajeId']) && (
                  <Col md="2">
                    <MaterialUI.RaisedButton label="Viaje" onTouchTap={() => functions.verViaje(registro.getIn(['data', 'viajeId']))} secondary={true} fullWidth={true} />
                  </Col>
                )}
                <Col md="2">
                  <MaterialUI.RaisedButton
                    label="Abonado"
                    onTouchTap={() =>
                      functions.verAbonado(
                        registro.getIn(['data', 'usuarioId']) ? registro.getIn(['data', 'usuarioId']) : false,
                        registro.getIn(['data', 'abonadoId']) ? registro.getIn(['data', 'abonadoId']) : false,
                      )
                    }
                    secondary={true}
                    fullWidth={true}
                  />
                </Col>
                <Col md="2" className="pt-10">
                  <p>
                    <b>
                      <FontAwesome name="clock-o" /> {moment(registro.get('fechaCreado')).format('HH:mm')}
                    </b>
                  </p>
                </Col>
              </Row>
            }
          />
          <MaterialUI.Divider />
        </div>
      );
    default:
      return false;
  }
}



// WEBPACK FOOTER //
// src/modules/registros/components/main.js